<template>
    <div class="navs">
        <el-menu mode="vertical" default-active="1" background-color="#496cfc" text-color="#c5d3f8"
            active-text-color="#fff">
            <el-submenu index="1">
                <template slot="title">保险销售</template>
                <el-menu-item-group>
                    <el-menu-item index="1-1">
                        <router-link to="/agency/policySells"> 销售保单 </router-link>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3">
                <template slot="title">查询统计</template>
                <el-menu-item-group>
                    <el-menu-item index="3-1">
                        <router-link to="/agency/agencyPolicyList"> 查询保单 </router-link>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
        <div class="date-tips" v-if="false">
            <a class="date-tips-btn" href="javascript:void(0);" @click="dateEditShow = true">修改</a>
            <div class="date-wrap">
                <div class="date-tips-tit">旅行社责任险</div>
                <div class="date-item-tips" :class="{ red: overLibilitytime }">
                    <em class="date-tips-min">到期日</em>
                    <span>{{ liabilitytime.substr(0, 10) }}</span>
                </div>
            </div>
            <div class="date-wrap">
                <div class="date-tips-tit">旅行社保证金保险</div>
                <div class="date-item-tips" :class="{ red: overBondtime }">
                    <em class="date-tips-min">到期日</em>
                    <span>{{ bondtime.substr(0, 10) }}</span>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="dateEditShow" title="日期修改" width="37%" modal>
            <el-form :model="userInfo" label-width="200px">
                <el-form-item label="旅行社责任险到期日">
                    <el-date-picker v-model="liabilitytime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                        style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="旅行社保证金保险到期日">
                    <el-date-picker v-model="bondtime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                        style="width: 100%;"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dateEditShow = false">取 消</el-button>
                <el-button type="primary" @click="sendDates">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
            dateEditShow: false,
            liabilitytime: JSON.parse(sessionStorage.getItem('userInfo')).TravelAgency_LiabilityTime,
            bondtime: JSON.parse(sessionStorage.getItem('userInfo')).TravelAgency_BondTime,
            overLibilitytime: false,
            overBondtime: false,
            now: "",
        }
    },
    mounted() {

        this.now = new Date().toLocaleDateString();
        this.overLibilitytime = Date.parse(this.now) > Date.parse(this.liabilitytime)
        this.overBondtime = Date.parse(this.now) > Date.parse(this.bondtime)
    },
    methods: {
        sendDates() {
            this.ipost('/AdminTravel/TravelAgency.ashx?type=chageselfinsurancetime', {
                liabilitytime: this.liabilitytime,
                bondtime: this.bondtime
            }, res => {
                this.dateEditShow = false
                this.userInfo.TravelAgency_LiabilityTime = this.liabilitytime
                this.userInfo.TravelAgency_BondTime = this.bondtime
                this.overLibilitytime = Date.parse(this.now) > Date.parse(this.liabilitytime)
                this.overBondtime = Date.parse(this.now) > Date.parse(this.bondtime)
                sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo))
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })


            })
        }
    }
};
</script>

<style scoped>
.date-tips {
    padding: 12px;
    font-size: 13px;
    color: #ffff;
    position: relative;
    border-radius: 4px;
    margin: 2px;
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.2);
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
}

.red {
    color: red;
}

.date-tips-tit {
    font-weight: bold;
    font-size: 14px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    letter-spacing: 1px;
}

.date-tips-btn {
    position: absolute;
    right: 3px;
    top: 3px;
    font-size: 12px;
    color: #ffffffb7;
}

.date-item-tips {
    position: relative;
    line-height: 37px;
}

.date-item-tips span {
    font-size: 16px;
}

.date-tips-min {
    font-size: 10px;
    margin-left: 8px;
    font-style: normal;
    transform: scale(.9);
    position: absolute;
    left: 83px;
    top: -6px;
}

.navs {
    height: 100%;
    background-color: #496cfc;
    overflow: hidden;
    overflow-y: auto;
}

.el-menu-item a {
    color: rgb(197 211 248);
    display: block;
}

.el-menu-item.is-active a {
    color: #fff;
}

.logo {
    background-color: #496cfc;
    height: 60px;
    text-align: center;
}

.logo img {
    height: 45px;
    margin-top: 7.5px;
}
</style>
